import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiRoutes } from 'src/app/config/api-routes';
import { Observable } from 'rxjs';

@Injectable()
export class AppAvailableLanguagesService {
  constructor(private http: HttpClient, private config: ApiRoutes) { }

  getLanguages(): Observable<any> {
    return this.http.get(this.config.LANGUAGES);
  }
}
